import { InputAdornment } from "@mui/material";
import MDBox from "components/MDBox";
import { ReactNode } from "react";
import { draftColors, draftTypography } from "modules/proposals/draft/draftDesignTokens";
import UiTypography from "./UiTypography";
import UiInput from "./UiInput";

type UiFieldGroupProps = {
  label: string;
  value: string;
  textAlign?: "left" | "right";
  fontWeight?: number;
  children?: ReactNode;
  inputProps?: Record<string, unknown>;
  placeholder?: string;
  readOnly?: boolean;
  startAdornment?: string;
  endAdornment?: string;
};

const adornmentSx = {
  "& .MuiTypography-root": {
    fontSize: draftTypography.body12.fontSize,
    color: draftColors.textSecondary,
  },
};

export default function UiFieldGroup({
  label,
  value,
  textAlign = "left",
  fontWeight,
  children,
  inputProps,
  placeholder,
  readOnly,
  startAdornment,
  endAdornment,
}: UiFieldGroupProps) {
  const { ref: inputRef, ...restInputProps } = (inputProps ?? {}) as any;

  const InputProps: Record<string, ReactNode> = {};
  if (startAdornment) {
    InputProps.startAdornment = (
      <InputAdornment position="start" sx={adornmentSx}>
        {startAdornment}
      </InputAdornment>
    );
  }
  if (endAdornment) {
    InputProps.endAdornment = (
      <InputAdornment position="end" sx={adornmentSx}>
        {endAdornment}
      </InputAdornment>
    );
  }

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      gap="4px"
      p="6px 8px 8px"
      borderRadius="8px"
      border={`1px solid ${draftColors.border}`}
    >
      <UiTypography uiVariant="label-xs" sx={{ color: draftColors.textLabel }}>
        {label}
      </UiTypography>
      {children ?? (
        <UiInput
          fullWidth
          placeholder={placeholder ?? value}
          textAlign={textAlign}
          fontWeight={fontWeight}
          readOnly={readOnly}
          inputRef={inputRef}
          InputProps={InputProps}
          {...restInputProps}
        />
      )}
    </MDBox>
  );
}
